import { TaskStatusType } from '../Task.enums'
import { QA_NAME_TASK_STATUS_TOGGLE } from '../TaskStatusToggle'

export const QA_NAME_TASK_TABLE_ROW_YES_NO_STATUS = {
  [TaskStatusType.No]: `${QA_NAME_TASK_STATUS_TOGGLE}No`,
  [TaskStatusType.Yes]: `${QA_NAME_TASK_STATUS_TOGGLE}Yes`,
}
